const t = {
  name: "Accounts",
  dimensions: { width: 20, height: 21 },
  content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round">
      <rect x="1" y="1.25" width="7" height="7" rx="1" />
      <rect x="12" y="12.25" width="7" height="7" rx="1" />
      <rect x="12" y="1.25" width="7" height="7" rx="1" />
      <rect x="1" y="12.25" width="7" height="7" rx="1" />
    </g>
  `
};
export {
  t as Accounts
};
